//importing project images
import apiapp from './projects/images/apiapp.png';
import cartapp from './projects/images/cartapp.png';
import quizapp from './projects/images/quizapp.png';
import todoapp from './projects/images/todoapp.png';
import covidWebsite from './projects/images/covidWebsite.png'
import ecommWebsite from './projects/images/ecommWebsite.png'
import Blogwebsite from './projects/images/Blogwebsite.png'

 let workdata=[
    {
        "id":0,
        "imgsrc":apiapp,
        "title":"API app mini project",
        "techUsed":"React.js,Bootstrap",
        "conceptUsed":"React,Axios,Functional component,Hooks",
        "desc":"In this mini project i am showing current crypto currency market prices and other data related to it by fetching it from API",
        "github":"https://github.com/AbuFaishal/ApiApp.git",
        "type":"react",
    },
    {
        "id":1,
        "imgsrc":cartapp,
        "title":"Cart System mini project",
        "techUsed":"React.js",
        "conceptUsed":"React,Fetch method of js,Functional component,Hooks,Context API",
        "desc":"In this mini project i am showing a mini cart where i added some product and we can increment or decrement its quantity and according to quantity its overall price changes",
        "github":"https://github.com/AbuFaishal/CartSystem.git",
        "type":"react"
    },
    {
        "id":2,
        "imgsrc":quizapp,
        "title":"Quiz app mini project",
        "techUsed":"React.js",
        "conceptUsed":"React,Functional component,Hooks",
        "desc":"This project takes a little quiz test which contain timer for each question if we do not answer between time it will move on to next question and at the end it will count total score and show the result",
        "github":"https://github.com/AbuFaishal/QuizApp.git",
        "type":"react"
    },
    {
        "id":3,
        "imgsrc":todoapp,
        "title":"Todo app mini project using Redux",
        "techUsed":"React.js,Bootstrap",
        "conceptUsed":"React,Functional component,Hooks,Redux",
        "desc":"We use Todo app to keep track our scheduled work. In this mini project i created a mini project of todo app using redux flow",
        "github":"https://github.com/AbuFaishal/TodoApp.git",
        "type":"react"
    },
    {
        "id":4,
        "imgsrc":Blogwebsite,
        "title":"HeavenBlogs",
        "techUsed":"Html,css,js,bootstrap,react.js,node.js,express.js,mongodb,rest api,cloudinary",
        "desc":"This is my first cms project made on complete mern stack.In this website user can register and create any blog of there choice which will be monitered by the admin.",
        "github":"https://github.com/AbuFaishal/heavenblogs",
        "type":"mern",
        "source":"https://heavenblogs.herokuapp.com/"
    }
]

export default workdata;